/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */

/* eslint-disable no-bitwise */
'use es6';

import { FINDER_ASSET_DESELECT, FINDER_ASSET_TOGGLE_SELECTION, FINDER_DESELECT_ALL, FINDER_ASSET_TOGGLE_SELECTIONS, FINDER_ASSET_REVEAL_IN_FINDER } from 'DesignData/actions/ActionTypes';
import { setActiveThemeFolderId } from 'DesignData/actions/finder/Themes';
import { setActiveProjectFolderId } from 'DesignData/actions/finder/Projects';
import { fetchDefault } from 'DesignData/actions/finder/FileMapper';
import { FOLDER } from 'DesignData/constants/FolderAssetTypes';
import { tryParseInt } from 'DesignData/lib/text';
import { getLastSelectedAssetId, getLastDeselectedAssetId, makeGetAssets, getActiveThemeFolderId, getActiveProjectFolderId, makeGetAssetParentThemeFolderId, makeGetAssetParentProjectFolderId, getFile, getIsHubspotFolder } from 'DesignData/selectors/finder';
const getAssets = makeGetAssets();
const getAssetParentThemeFolderId = makeGetAssetParentThemeFolderId();
const getAssetParentProjectFolderId = makeGetAssetParentProjectFolderId();
export function selectFile(fileId, fileType, parentFolderId, isMultiSelect = false) {
  return {
    type: FINDER_ASSET_TOGGLE_SELECTION,
    assetId: fileId,
    assetType: fileType,
    parentFolderId,
    isMultiSelect
  };
}
export function selectFolder(folderId, parentFolderId, isMultiSelect = false) {
  return {
    type: FINDER_ASSET_TOGGLE_SELECTION,
    assetId: folderId,
    assetType: FOLDER,
    parentFolderId,
    isMultiSelect
  };
}
export function shiftSelectAsset(assetId) {
  return (dispatch, getState) => {
    const state = getState();
    const lastSelectedAssetId = getLastSelectedAssetId(state);
    const lastDeselectedAssetId = getLastDeselectedAssetId(state);
    const finderNodes = document.querySelectorAll('div[data-finder-node-id]');
    const visibleIds = [...finderNodes].map(li => tryParseInt(li.dataset.finderNodeId, 10));
    const startingIndex = lastSelectedAssetId ? visibleIds.indexOf(lastSelectedAssetId) : 0;
    const endingIndex = visibleIds.indexOf(assetId);
    const [start, end] = [startingIndex, endingIndex].sort((a, b) => a - b);
    const assetIds = visibleIds.slice(start, end + 1);
    const assets = getAssets(state, {
      assetIds
    });
    const shiftMultiSelect = !!lastDeselectedAssetId && !~assetIds.indexOf(lastDeselectedAssetId);
    return dispatch({
      type: FINDER_ASSET_TOGGLE_SELECTIONS,
      assets,
      assetIds,
      shiftMultiSelect
    });
  };
}
export function deselectAll() {
  return {
    type: FINDER_DESELECT_ALL
  };
}
export function deselectAsset(assetId) {
  return {
    type: FINDER_ASSET_DESELECT,
    assetId
  };
}

function __revealInFinder(assetId, openFinder = true) {
  return (dispatch, getState) => {
    if (!assetId) return;
    const state = getState();
    const props = {
      assetId
    };
    const assetParentThemeFolderId = getAssetParentThemeFolderId(state, props);
    const activeThemeFolderId = getActiveThemeFolderId(state);
    const assetParentProjectFolderId = getAssetParentProjectFolderId(state, props);
    const activeProjectFolderId = getActiveProjectFolderId(state);

    if (assetParentThemeFolderId && activeThemeFolderId !== assetParentThemeFolderId) {
      // Open theme folder view if requested asset is in a theme folder
      // and the theme is not already active.
      dispatch(setActiveThemeFolderId(assetParentThemeFolderId));
    } else if (!assetParentThemeFolderId && activeThemeFolderId) {
      // Close theme folder view if requested asset is not in a theme folder
      // and a theme folder view is presently active.
      dispatch(setActiveThemeFolderId(null));
    }

    if (assetParentProjectFolderId && activeProjectFolderId !== assetParentProjectFolderId) {
      // Open theme folder view if requested asset is in a theme folder
      // and the theme is not already active.
      dispatch(setActiveProjectFolderId(assetParentProjectFolderId));
    } else if (!assetParentProjectFolderId && activeProjectFolderId) {
      // Close theme folder view if requested asset is not in a theme folder
      // and a theme folder view is presently active.
      dispatch(setActiveProjectFolderId(null));
    }

    dispatch({
      type: FINDER_ASSET_REVEAL_IN_FINDER,
      assetId,
      openFinder
    });
    const file = getFile(state, {
      fileId: assetId
    });

    if (file) {
      dispatch(selectFile(file.id, file.type, file.folderId));
    }
  };
}

function __revealHubSpotInFinder(assetId, openFinder = true) {
  return dispatch => {
    const req = dispatch(fetchDefault());
    req.then(() => {
      dispatch(__revealInFinder(assetId, openFinder));
    });
  };
}

export function revealInFinder(assetId, openFinder = true) {
  return (dispatch, getState) => {
    if (!assetId) return;
    const state = getState();
    const props = {
      assetId
    };

    if (getIsHubspotFolder(state, props)) {
      dispatch(__revealHubSpotInFinder(assetId, openFinder));
    } else {
      dispatch(__revealInFinder(assetId, openFinder));
    }
  };
}